import { createTheme } from '@mui/material';

const muiFormTheme = createTheme({
  typography: {
    fontFamily: 'inherit',
  },
});

export default muiFormTheme;
